import _ from 'lodash';
import async from 'async';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import { validateEmail } from '../../libs/utility';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/Button';
import FMPText from '../pureForm/FMPText';
import DeleteIcon from '@material-ui/icons/Delete';
import StationInvoiceContainer from "../../containers/accounting/StationInvoice";
import InvoiceCreditMemoContainer from "../../containers/accounting/InvoiceCreditMemo";
import FMPSectionHeader from "../ui/FMPSectionHeader";
import GenericSavingDialog from "./GenericSavingDialog";
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		maxWidth : '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin : 10,
	},
	submitButton : {
		fontSize : 18,
		borderRadius : '100px',
		padding : '20px 30px',
		textTransform: 'uppercase'
	},
	addInputButton : {
		borderRadius : '100px',
		marginTop : 20,
	},
	attachment :  {
		position : 'absolute',
		width:'100%',
		height : '100%',
		border : '1px solid #ddd'
	},
	emailBody : {
		border : '1px solid #ddd',
	},
	invoiceDocuments : {
		display: 'flex',
		flexWrap: 'wrap',
		alignContent: 'stretch',
		justifyContent: 'space-between',
		marginTop : 20,
	},
	invoicePage : {
		width : '33%',
		padding : 5,
		boxSizing : 'border-box',
	},
	invoicePageImg : {
		width : '100%',
		height : '100%',
		border : '1px solid #ddd',
	},
	pageSection : {
		borderBottom : '2px dashed #ccc',
		marginBottom : 30,
		paddingBottom : 30,
	},
});

class InvoiceSendConfirmationDialog extends Component {
	constructor (props) {
		super(props);
		this.state = {
			stationInvoiceId: undefined,
			additionalInvoiceEmails : [],
			formFieldError : {},
			emailNote : '',
			isSavingOpen : false,
			savingStatus : undefined,
		};
	}

	/*
	componentDidMount() {
		const {
			stationInvoiceId,
			stationInvoice, getStationInvoice,
		} = this.props;

		if (stationInvoice) {
			const { additionalInvoiceEmails} = stationInvoice;
			this.setState({ additionalInvoiceEmails });
		} else {
			getStationInvoice({
				params: {
					includeQuickbooksCustomers: true,
					stationInvoiceIds: [stationInvoiceId]
				}
			});
		}
	}
	*/

	componentDidUpdate(prevProps, prevState) {

		const {
			getStationInvoiceEmailInfo,
			showErrors
		} = this.props;

		if (
			_.isUndefined(prevProps.stationInvoice)
			&& !_.isUndefined(this.props.stationInvoice)
		) {
			const { additionalInvoiceEmails} = this.props.stationInvoice;
			this.setState({ additionalInvoiceEmails });
		}

		//- Every time it opens get the email info
		if (
			!prevProps.open &&
			this.props.open &&
			this.props.stationInvoice
		) {
			const { stationInvoiceId } = this.props.stationInvoice;

			getStationInvoiceEmailInfo({
				params : { stationInvoiceId },
				callback : (err, r) => {
					if (err) {
						return showErrors([err]);
					}
					if (!r) {
						return showErrors(['No result from getEmailInfo']);
					}

					const { subject, emailBody } = r;
					if (!subject || !emailBody) {
						return showErrors(['Missing subject or body']);
					}

					this.setState({ subject, emailBody });
				}
			});
		}

		if (prevState.emailNote !== this.state.emailNote) {

			if (this.state.emailNote) {
				const container = document.getElementById('emailNoteContainer');
				if (container) {
					container.style.display = 'block';
				}
			} else {
				const container = document.getElementById('emailNoteContainer');
				if (container) {
					container.style.display = 'none';
				}
			}

			const div = document.getElementById('emailNote');
			if (div) {
				div.innerHTML = this.state.emailNote;
				div.textContent = this.state.emailNote;
			}
		}

	}

	addInput = (arrayName) => {
		this.setState({ [arrayName] : this.state[arrayName].concat(['']) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName] : inputs });
	};


	handleClose = () => {
		this.props.onClose();
	};

	handleSendInvoice = () => {
		const {
			stationInvoice,
			sendStationInvoice,
			sendInvoiceCreditMemo,
			creditMemo,
			showErrors,
		} = this.props;

		const {
			additionalInvoiceEmails,
			emailNote,
		} = this.state;

		const formFieldError = {};
		additionalInvoiceEmails.forEach((email, i) => {
			if (validateEmail(email)) { return; }
			_.set(formFieldError, ['additionalInvoiceEmails', i], 'Invalid characters in email');
		});

		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSavingOpen: true,
			savingStatus: 'activating'
		});

		const { stationInvoiceId } = stationInvoice;

		//- Credit & rebill: the whole sequence (emails, QB credit memo, apply, rebill)
		//- goes through invoiceCreditMemo.send instead of the plain invoice send
		if (creditMemo) {
			const params = {
				invoiceCreditMemoId: creditMemo.invoiceCreditMemoId,
			};
			if (emailNote) {
				params.emailNote = emailNote;
			}
			if (!_.isEmpty(additionalInvoiceEmails)) {
				params.additionalInvoiceEmails = additionalInvoiceEmails;
			}

			setTimeout(() => {
				sendInvoiceCreditMemo({
					params,
					callback: (err) => {
						if (err) {
							this.setState({ isSavingOpen: false });
							return showErrors(_.isArray(err) ? err : [err]);
						}
						this.setState({ savingStatus: 'done' });
					},
				});
			}, 1000);
			return;
		}

		const params = {
			stationInvoiceId,
		};

		if (!_.isEmpty(additionalInvoiceEmails)) {
			params.additionalInvoiceEmails = additionalInvoiceEmails;
		}
		if (emailNote) {
			params.emailNote = emailNote;
		}

		setTimeout(() => {
			async.waterfall([
				callback => {
					sendStationInvoice({
						params,
						callback
					});
				},
			], err => {
				//- error popup is already shown
				if (err) {
					this.setState({ isSavingOpen : false });
					return showErrors([err]);
				}
				this.setState({savingStatus: 'done'});
			});
		}, 1000);
	};

	renderErrorDialog = (error) => {
		const { classes, fullScreen } = this.props;
		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						Error Encountered
					</DialogTitle>
				</div>
				<DialogContent>
					{error}
				</DialogContent>
			</Dialog>
		);
	};

	renderInfoDialog = (info) => {
		const { classes, fullScreen } = this.props;
		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						Loading info
					</DialogTitle>
				</div>
				<DialogContent>
					{info}
				</DialogContent>
			</Dialog>
		);
	};

	onChange = (value, path) => {
		const arrayPath = (_.isString(path))
			? _.toPath(path)
			: path;

		const val = (_.isObject(value) && value.target)
			? value.target.value
			: value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	closeSavingDialog = () => {
		this.setState({ isSavingOpen: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/accounting/stationInvoices/issued`);
	};

	render () {
		const {
			classes,
			stationInvoice,
			stationMap,
			fullScreen,
			open,
			invoiceDocumentMap,
			resourceMap,
			gasFormulaMap,
			quickbooksCustomerMap,
		} = this.props;

		const {
			additionalInvoiceEmails,
			subject, emailBody,
		} = this.state;


		if (!open) {
			if (!stationInvoice || !subject || !emailBody)  { return null; }
		} else {
			if (!stationInvoice || !subject || !emailBody)  {
				return this.renderInfoDialog('Loading info...');
			}
		}

		const { printableUrl, printableFormulaUrl, stationId, invoiceDocumentIds, productType } = stationInvoice;
		const {isSavingOpen, savingStatus} = this.state;

		const station = stationMap[stationId];
		if (!station) {
			return this.renderErrorDialog('Missing station');
		}

		const { gasFormulaId, invoiceQuickbooksCustomerId, invoiceEmails} = station;
		if (!invoiceQuickbooksCustomerId) {
			return this.renderErrorDialog('Station not linked to quickbooks customer');
		}

		const quickbooksCustomer = quickbooksCustomerMap[invoiceQuickbooksCustomerId];
		if (!quickbooksCustomer) {
			return this.renderErrorDialog('Could not lookup quickbooks customer');
		}

		if (_.isEmpty(invoiceEmails)) {
			return this.renderErrorDialog('Station needs at least one invoice email');
		}

		const isE85 = (productType === 'e85');
		let showFormulaPage = false;
		if (isE85) {
			const gasFormula = gasFormulaMap[gasFormulaId];
			if (!gasFormula) {
				return this.renderErrorDialog(`Missing gasFormulaId  ${gasFormulaId}`);
			}

			const {formulaKey} = gasFormula;
			const isFalcon = (formulaKey === 'falconFormula');

			//- Mirrors the backend emailInvoice gate: falcon always gets the formula
			//- sheet; flagged stations get it on quoted-price invoices only
			const isGm = (formulaKey === 'g&mE85');
			const includeFormulaBreakdown = !!(
				station.includeFormulaBreakdownOnInvoices &&
				!isGm &&
				!stationInvoice.requireUnlPriceOnInvoicing &&
				stationInvoice.stationQuotedPriceId
			);
			showFormulaPage = isFalcon || includeFormulaBreakdown;
		}

		const invoicePages = [];
		if (!_.isEmpty(invoiceDocumentIds)) {
			invoiceDocumentIds.forEach(invoiceDocumentId => {
				const invoiceDocument = invoiceDocumentMap[invoiceDocumentId]
					|| { isMissing : true, pageResourceIds : []};

				const { pageResourceIds } = invoiceDocument;
				pageResourceIds.forEach((resourceId, i) => {
					const resource = resourceMap[resourceId] ||
						{ isMissing : true};

					invoicePages.push({
						url : resource.url,
						pageNumber : i + 1,
					});
				})
				;
			});
		}

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth='md'
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						{this.props.creditMemo
							? `Verify and Send Credit & Rebill (Credit Memo #${this.props.creditMemo.invoiceCreditMemoId})`
							: 'Verify and Send Invoice'}
					</DialogTitle>
					<DialogContent>
						<FMPSectionHeader label={"Invoice Email Recipients"} />
						<div>
							{invoiceEmails.map((n, i) => {
								return (<div style={{paddingTop:3}} key={i}>{n}</div>);
							})}
						</div>

						{additionalInvoiceEmails.map((email, i) => {
							const path = `additionalInvoiceEmails.${i}`;
							return (<Grid container spacing={2} key={i}>
								<FMPText
									label={'Email'}
									path={path}
									value={this.getValue(path)}
									error={this.getError(path)}
									onChange={this.onChange}
									md={6}
									contained={false}
								/>
								<Grid item xs={1} md={1} style={{display : 'flex'}}>
									<IconButton
										color="primary"
										aria-label="Delete"
										onClick={() => this.removeInput('additionalInvoiceEmails', i)}
									>
										<DeleteIcon/>
									</IconButton>
								</Grid>
							</Grid>);
						})}

						<div style={{display : 'flex'}}>
							<Button
								variant="contained"
								className={classes.addInputButton}
								onClick={() => this.addInput('additionalInvoiceEmails')}
							>
								ADD ADDITIONAL INVOICE EMAIL
							</Button>
						</div>

						<br/>
						<FMPText
							label={'Email Note'}
							path={'emailNote'}
							value={this.getValue('emailNote')}
							error={this.getError('emailNote')}
							multiline={2}
							onChange={this.onChange}
						/>

						<FMPSectionHeader label={"Email Subject"} />
						<div>
							{subject}
						</div>

						<FMPSectionHeader label={"Email Body"} />
						<div className={classes.emailBody}>
							<div dangerouslySetInnerHTML={{__html : emailBody }} />
						</div>

						<FMPSectionHeader label={"Invoice Attachments"} />

						<div style={{marginTop : 20, width:'100%', paddingBottom : '129.4%', position : 'relative'}}>
							<iframe
								frameBorder="0"
								title={'Printable Invoice'}
								className={classes.attachment}
								src={printableUrl}
							/>
						</div>

						{showFormulaPage &&
						<div style={{marginTop : 20, width:'100%', paddingBottom : '129.4%', position : 'relative'}}>
							<iframe
								frameBorder="0"
								title={'Printable Formula'}
								className={classes.attachment}
								src={printableFormulaUrl}
							/>
						</div>
						}

						{!!this.props.creditMemo &&
						<Fragment>
							<FMPSectionHeader label={"Credit Memo"} />
							<div>
								{this.props.creditMemo.rebillType === 'rebill'
									? 'Attached to this email alongside the invoice above.'
									: 'Emailed SEPARATELY to the original customer, crediting their invoice in full.'}
							</div>
							<div style={{marginTop : 20, width:'100%', paddingBottom : '129.4%', position : 'relative'}}>
								<iframe
									frameBorder="0"
									title={'Printable Credit Memo'}
									className={classes.attachment}
									src={this.props.creditMemo.printableUrl}
								/>
							</div>
						</Fragment>
						}

						<div className={classes.invoiceDocuments}>
							{invoicePages.map((invoicePage, i) => {
								const { url } = invoicePage;

								return (<div key={i} className={classes.invoicePage}>
									<img alt={`Delivery document page ${i}`} src={url} className={classes.invoicePageImg}/>
								</div>);
							})}
						</div>

					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Cancel
						</Button>
						<Button
							disabled={isSavingOpen}
							variant="contained"
							onClick={this.handleSendInvoice}
							className={classes.submitButton}
							color="primary"
						>
							{this.props.creditMemo
								? 'Email credit & rebill, import to quickbooks'
								: 'Email invoice & import to quickbooks'}
						</Button>
					</DialogActions>
				</div>

				<GenericSavingDialog
					open={isSavingOpen}
					onClose={this.closeSavingDialog}
					onContinue={this.continueSavingDialog}
					processingText={"Generating invoice, collating pages, sending emails, importing to quickbooks..."}
					successText={"Invoice emails sent and imported to quickbooks successfully."}
					status={savingStatus}
				/>

			</Dialog>
		);
	}
}

InvoiceSendConfirmationDialog.propTypes = {
	stationInvoice : PropTypes.object,
	//getStationInvoice : PropTypes.func.isRequired,

	//- credit & rebill mode: set when the invoice being sent is a rebill
	creditMemo : PropTypes.object,
	sendInvoiceCreditMemo : PropTypes.func,

	sendStationInvoice : PropTypes.func.isRequired,
	stationMap : PropTypes.object,
	gasFormulaMap : PropTypes.object,
	invoiceDocumentMap : PropTypes.object,
	resourceMap : PropTypes.object,
	quickbooksCustomerMap : PropTypes.object,
	getStationInvoiceEmailInfo : PropTypes.func,

	classes: PropTypes.object.isRequired,
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors : PropTypes.func,
	history : PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
	StationInvoiceContainer,
	InvoiceCreditMemoContainer,
])(InvoiceSendConfirmationDialog);